// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"_V-z","sponsoredTooltipWrapper":"aW-z","sponsoredTooltip":"bW-z","newCard":"cW-z"};